import type { FaireProductEntity } from "../../entity_types/product";

export const p_evc386g: FaireProductEntity = {
  token: "p_evc386g",
  type: "product",
  name: "Spiced Roasted Cashews",
  brandName: "Bronx Nut Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/81ebfd253f3f1180daec372eb07e1e8beb72b709131aed754d9f877db4db8335.jpeg",
  priceDollars: 14,
  description: "Premium cashews roasted with aromatic spices",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "spicy", "roasted"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81ebfd253f3f1180daec372eb07e1e8beb72b709131aed754d9f877db4db8335.jpeg",
  weight: 0.7,
  dimensions: {
    width: 4,
    height: 7,
    depth: 2,
  },
  inStock: true,
};
